import Vue from 'vue'

const eventEmit = new Vue()

export default eventEmit
